import { FormControl, InputLabel, Select } from '@material-ui/core';
import React, { FC } from 'react';
import { LegacyEmployee } from '../../../../../../interfaces/api/Employee';

interface Props {
  className?: string;
  userId: number;
  employees: LegacyEmployee[];
  onChange: (employeeId: number) => void;
}

const EmployeeSelect: FC<Props> = ({ className, onChange, employees, userId }) => {
  const handleChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const userId = parseInt(event.target.value as string);
    onChange(userId);
  };

  return (
    <FormControl className={className}>
      <InputLabel>Employé</InputLabel>
      <Select native onChange={handleChange} value={userId}>
        {employees.map((employee, key) => (
          <option value={employee.user?.id} key={key}>
            {`${employee.firstname} ${employee.lastname}`}
          </option>
        ))}
        <option value={-1}>Tout afficher</option>
      </Select>
    </FormControl>
  );
};

export default EmployeeSelect;
